/**
 * If the text is longer than the max characters specified
 * this component will cut the display of the text to the max chars
 * and add ellipsis at the end, and show the full text in a tooltip
 *
 * If the text is less than the max chars, nothing will happen to
 * the display.
 *
 * Important to know:
 *
 * The child of this component should always be a string.
 *
 * Improvements to be done?
 *
 * Yes, we need to have some sort of validation
 * if no string is passed, otherwise it might break.
 * @param {*} param0
 * @returns
 */
const Ellipsis = ({ children, maxChars = 20, tooltip = true }) => {

    if (!children) { return null; }

    const ellipsis = children.length > maxChars ? '...' : '';
    const text = `${children.slice(0, maxChars)}${ellipsis}`;

    const tooltipProps = ellipsis && tooltip ? {
        className: 'has-tooltip-arrow',
        'data-tooltip': children
    } : {};

    return (
        <span {...tooltipProps}>{text}</span>
    );
};

export { Ellipsis };
